<template>
  <!-- 顶部空白 -->
  
  <!-- 交易规则详情弹窗 -->
  <el-dialog
    title="河南科技成果与知识产权交易服务平台 交易规则(试行)"
    v-model="rulesDialogVisible"
    width="70%"
    :modal="true"
    :before-close="handleRulesDialogClose"
    class="rules-dialog"
  >
    <div class="dialog-content">
      <div class="rules-text" v-html="rulesContent"></div>
    </div>
  </el-dialog>

  <!-- 成果展示详情弹窗 -->
  <el-dialog
    v-model="achievementDialogVisible"
    :title="achievementDialogTitle"
    width="900px"
    :before-close="handleAchievementDialogClose"
    class="custom-dialog"
  >
    <div class="dialog-content">
      <!-- 专利技术 -->
      <div v-if="achievementActiveTab === '专利技术'" class="detail-section">
        <div class="detail-item">
          <div class="detail-label">专利名称：</div>
          <div class="detail-value">{{ achievementDetailData.title }}</div>
        </div>
        <div class="detail-item">
          <div class="detail-label">专利类型：</div>
          <div class="detail-value">{{ achievementDetailData.patentType }}</div>
        </div>
        <div class="detail-item">
          <div class="detail-label">申请方：</div>
          <div class="detail-value">{{ achievementDetailData.applicant }}</div>
        </div>
        <div class="detail-item">
          <div class="detail-label">发明人：</div>
          <div class="detail-value">{{ achievementDetailData.inventorDesigner }}</div>
        </div>
        <div class="detail-item">
          <div class="detail-label">申请日期：</div>
          <div class="detail-value">{{ achievementDetailData.applicationDate }}</div>
        </div>
        <div class="detail-item">
          <div class="detail-label">专利摘要：</div>
          <div class="detail-value">{{ achievementDetailData.abstractText || '暂无摘要信息' }}</div>
        </div>
      </div>

      <!-- 科技成果 -->
      <div v-if="achievementActiveTab === '科技成果'" class="detail-section">
        <div class="detail-item">
          <div class="detail-label">成果名称：</div>
          <div class="detail-value">{{ achievementDetailData.achievementName }}</div>
        </div>
        <div class="detail-item">
          <div class="detail-label">服务产业：</div>
          <div class="detail-value">{{ achievementDetailData.industryType }}</div>
        </div>
        <div class="detail-item">
          <div class="detail-label">成果介绍：</div>
          <div class="detail-value">{{ achievementDetailData.achievementIntro }}</div>
        </div>
        <div class="detail-item">
          <div class="detail-label">应用情况：</div>
          <div class="detail-value">{{ achievementDetailData.applicationStatus }}</div>
        </div>
        <div class="detail-item">
          <div class="detail-label">团队介绍：</div>
          <div class="detail-value">{{ achievementDetailData.teamIntro }}</div>
        </div>
        <div class="detail-item contact-info">
          <div class="detail-label">联系人：</div>
          <div class="detail-value">{{ achievementDetailData.contactPerson }}</div>
          <div class="detail-label" style="margin-left: 40px;">联系方式：</div>
          <div class="detail-value">{{ achievementDetailData.contactInfo }}</div>
        </div>
      </div>
    </div>
  </el-dialog>

  <!-- 主横幅区域 -->
  <div class="banner">
    <div class="banner-title-wrapper">
      <div class="banner-title-part1">一站式</div>
      <div class="banner-title-part2">技术交易</div>
      <div class="banner-title-part3">服务平台</div>
    </div>
    <div class="banner-subtitle">连接创新资源 · 促进成果转化 · 赋能产业升级</div>
    <div class="banner-buttons">
      <a href="http://39.105.114.210:13307/login" target="_blank" class="btn btn-primary">
        <img src="../assets/img/index/wd.png" alt="交易登记" class="btn-icon">
        <span class="btn-text">
          <span class="btn-title">交易登记</span>
<!--          <span class="btn-subtitle">TRANSACTION REGISTRATION</span>-->
        </span>
        <img src="../assets/img/index/Container.png" alt="箭头" class="btn-arrow">
      </a>
      <a href="https://ctmht.chinatorch.org.cn/admin/login" target="_blank" class="btn btn-secondary">
        <img src="../assets/img/index/jshtdj.png" alt="技术合同登记" class="btn-icon">
        <span class="btn-text">
          <span class="btn-title">技术合同登记</span>
<!--          <span class="btn-subtitle">CONTRACT REGISTRATION</span>-->
        </span>
        <img src="../assets/img/index/Container.png" alt="箭头" class="btn-arrow">
      </a>
    </div>
    <div class="stats-container">
      <div class="stat-item" v-for="item in displayStats" :key="item.key">
        <div class="stat-label">{{ item.name }}</div>
        <div class="stat-number">{{ item.displayValue }}<span class="stat-unit">{{ item.unit }}</span></div>
      </div>
    </div>
  </div>

  <!-- 内容区域 -->
  <div class="main-content">
    <!-- 媒体中心 -->
<div style="width: 100%; background-color: #ffffff; padding-top:40px;padding-bottom: 1px;">
      <section class="section media-center" >
      <div class="section-title media-section-title" style="border-bottom: 1px solid #E2E8F0; padding-bottom: 10px;">
        <div class="title-left">
          <img src="../assets/img/index/Icon.png" alt="媒体中心" class="title-icon-box">
          <div class="media-title-group">
            <h2>媒体中心</h2>
<!--            <p class="media-subtitle">MEDIA CENTER</p>-->
          </div>
        </div>
        <a href="javascript:void(0)" class="more-link" @click="goToMtzx">更多 ></a>
      </div>
      <div class="media-box">
        <div class="media-video" v-if="featuredNews.length > 0">
          <el-carousel indicator-position="outside" :autoplay="true" :interval="5000" style="width: 764px; height: 320px;">
            <el-carousel-item v-for="(item, index) in featuredNews" :key="index" style="width: 764px; height: 320px;" @click="handleNewsClick(item)">
              <img v-if="item.coverImage" :src="item.coverImage" :alt="item.title" class="media-image">
              <img v-else src="../assets/img/q1.png" :alt="item.title" class="media-image">
              <div class="media-overlay">
                <span class="media-tag">头条新闻</span>
                <span class="media-title">{{ item.title }}</span>
                <span class="media-date">{{ item.publishTime ? item.publishTime.slice(0, 10) : '' }}</span>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="media-list">
          <div 
            v-for="(item, index) in regularNews" 
            :key="index" 
            class="media-item"
            @click="handleNewsClick(item)"
          >
            <span class="media-item-bullet">•</span>
            <span class="media-item-title">{{ item.title }}</span>
            <span class="media-item-date">{{ item.publishTime ? item.publishTime.slice(5, 10) : '' }}</span>
          </div>
          <div class="media-more">
            <a href="javascript:void(0)" class="media-more-link" @click="goToMtzx">查看更多资讯 ></a>
          </div>
        </div>
      </div>
    </section>
</div>

    <!-- 成果展示 -->
    <div style="width: 100%; background-color: #ffffff; padding-top:40px;padding-bottom: 1px;">
    <section class="section achievement-section">
      <div class="section-title media-section-title" style="border-bottom: 1px solid #E2E8F0; padding-bottom: 10px;">
        <div class="title-left">
          <img src="../assets/img/index/Container30.png" alt="成果展示" class="title-icon-box">
          <div class="media-title-group">
            <h2>成果展示</h2>
<!--            <p class="media-subtitle">ACHIEVEMENTS</p>-->
          </div>
        </div>
        <!-- tab 切换 -->
        <div class="achievement-tabs">
          <div
            v-for="tab in achievementTabs"
            :key="tab"
            :class="['achievement-tab-item', { 'achievement-tab-active': achievementActiveTab === tab }]"
            @click="achievementActiveTab = tab"
          >
            {{ tab }}
          </div>
        </div>
        <a href="javascript:void(0)" @click="goToSjzy" class="more-link">更多 ></a>
      </div>
      <div class="achievement-list" v-loading="achievementLoading">
        <div
          v-for="(item, index) in achievementData"
          :key="'achievement-' + index"
          class="achievement-item"
          @click="handleAchievementClick(item)"
        >
          <div class="achievement-content">
            <h3 class="achievement-title">{{ achievementActiveTab === '专利技术' ? item.title : item.achievementName }}</h3>
            <p class="achievement-desc">{{ achievementActiveTab === '专利技术' ? item.patentType : item.industryType }}</p>
          </div>
          <!-- <a href="javascript:void(0)" class="achievement-link">进行中</a> -->
        </div>
      </div>
    </section>
    </div>

    <!-- 意向挂牌 -->
     <div style="width: 100%; background-color: #F8FAFC; padding-top:40px;padding-bottom: 1px;">
    <section class="section intention-section">
      <div class="section-title media-section-title" style="border-bottom: 1px solid #E2E8F0; padding-bottom: 10px;">
        <div class="title-left">
          <img src="../assets/img/index/zxwz.png" alt="意向挂牌" class="title-icon-box">
          <div class="media-title-group">
            <h2>意向挂牌</h2>
<!--            <p class="media-subtitle">INTENTIONAL LISTINGS</p>-->
          </div>
        </div>
        <a href="javascript:void(0)" @click="goToJydt" class="more-link">更多 ></a>
      </div>
      <div class="intention-list" v-loading="intentionLoading">
        <div
          class="intention-item"
          v-for="(item, index) in intentionList"
          :key="'intention-' + index"
          @click="goToProjectDetail(item)"
          style="cursor:pointer;"
        >
          <div class="intention-content">
            <h3 class="intention-title">{{ item.projectName }}</h3>
            <p class="intention-desc">{{ item.industryType }}</p>
          </div>
          <span class="intention-price" v-if="item.listingPrice">{{ item.listingPrice }}万元</span>
          <span class="intention-price" v-else>--</span>
        </div>
        <div v-if="intentionList.length === 0 && !intentionLoading" style="text-align:center;padding:40px 0;color:#9CA3AF;">暂无数据</div>
      </div>
    </section>
</div>
    <!-- 推荐项目 -->
     
<div style="width: 100%; background-color: #ffffff; padding-top:40px;padding-bottom: 1px;">
    <section class="section recommendation-section">
      <div class="section-title media-section-title" style="border-bottom: 1px solid #E2E8F0; padding-bottom: 10px;">
        <div class="title-left">
          <img src="../assets/img/index/wx.png" alt="推荐项目" class="title-icon-box">
          <div class="media-title-group">
            <h2>推荐项目</h2>
<!--            <p class="media-subtitle">RECOMMENDED</p>-->
          </div>
        </div>
        <a href="javascript:void(0)" @click="goToRecommendation" class="more-link">更多 ></a>
      </div>
      
      <!-- 轮播容器 -->
      <div class="recommendation-carousel-wrapper" v-loading="recommendationLoading">
        <!-- 左箭头 -->
        <button 
          v-show="recommendationIndex > 0"
          class="carousel-arrow carousel-arrow-left" 
          @click="prevRecommendation"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>

        <!-- 卡片网格 -->
        <div class="recommendation-grid">
          <div 
            class="recommendation-item" 
            v-for="(item, index) in displayedRecommendations" 
            :key="'recommendation-' + index" 
            @click="goToProjectDetail(item)"
          >
            <div class="recommendation-image">
              <img v-if="item.img" :src="item.img" alt="推荐项目" style="width:100%;height:100%;object-fit:contain;">
              <img v-else src="../assets/img/q2.png" alt="推荐项目" style="width:100%;height:100%;object-fit:contain;">
              <span class="recommendation-tag">{{ item.tag }}</span>
            </div>
            <div class="recommendation-info">
              <h3 class="recommendation-title">{{ item.title }}</h3>
              <div class="recommendation-footer">
                <p class="recommendation-category">{{ item.category }}</p>
                <span class="recommendation-link">查看详情</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 右箭头 -->
        <button 
          v-show="recommendationIndex < recommendationProjects.length - 4"
          class="carousel-arrow carousel-arrow-right" 
          @click="nextRecommendation"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    </section>
</div>
    <!-- 特色产业 -->
    <div style="width: 100%; background-color: #ffffff; padding-top:40px;padding-bottom: 1px;">
    <section class="section featured-section">
      <div class="featured-header">
<!--        <p class="featured-subtitle">FEATURED INDUSTRIES</p>-->
        <h2 class="featured-title">特色产业</h2>
      </div>
      <div class="featured-grid">
        <!-- 第一行：4个项目 -->
        <div class="featured-row">
          <a href="https://sta.hnprec.com/zyng/#/" target="_blank" class="featured-item">
            <img src="../assets/img/1.png" alt="河南种业技术交易服务中心">
            <div class="featured-overlay">
              <div class="featured-text-wrapper">
                <p class="featured-text">河南种业技术交易服务中心</p>
                <div class="featured-underline"></div>
              </div>
            </div>
          </a>
          <a href="javascript:void(0)" class="featured-item">
            <img src="../assets/img/2.png" alt="数据要素交易服务中心">
            <div class="featured-overlay">
              <div class="featured-text-wrapper">
                <p class="featured-text">数据要素交易服务中心</p>
                <div class="featured-underline"></div>
              </div>
            </div>
          </a>
          <a href="javascript:void(0)" class="featured-item">
            <img src="../assets/img/3.png" alt="数字版权及数据知识产权交易服务中心">
            <div class="featured-overlay">
              <div class="featured-text-wrapper">
                <p class="featured-text">数字版权及数据知识产权交易服务中心</p>
                <div class="featured-underline"></div>
              </div>
            </div>
          </a>
          <a href="javascript:void(0)" class="featured-item">
            <img src="../assets/img/4.png" alt="碳达峰碳中和绿色技术交易服务中心">
            <div class="featured-overlay">
              <div class="featured-text-wrapper">
                <p class="featured-text">碳达峰碳中和绿色技术交易服务中心</p>
                <div class="featured-underline"></div>
              </div>
            </div>
          </a>
        </div>
        <!-- 第二行：3个项目 -->
        <div class="featured-row">
          <a href="javascript:void(0)" class="featured-item">
            <img src="../assets/img/5.png" alt="医学科学科技成果交易服务中心">
            <div class="featured-overlay">
              <div class="featured-text-wrapper">
                <p class="featured-text">医学科学科技成果交易服务中心</p>
                <div class="featured-underline"></div>
              </div>
            </div>
          </a>
          <a href="javascript:void(0)" class="featured-item">
            <img src="../assets/img/6.png" alt="中原食品产业数字及成果交易服务中心">
            <div class="featured-overlay">
              <div class="featured-text-wrapper">
                <p class="featured-text">中原食品产业数字及成果交易服务中心</p>
                <div class="featured-underline"></div>
              </div>
            </div>
          </a>
          <a href="javascript:void(0)" class="featured-item">
            <img src="../assets/img/7.png" alt="中原中医药科技成果交易服务中心">
            <div class="featured-overlay">
              <div class="featured-text-wrapper">
                <p class="featured-text">中原中医药科技成果交易服务中心</p>
                <div class="featured-underline"></div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </section>
    </div>

    <!-- 科创金融 -->
     <div style="width: 100%; background-color: #ffffff; padding-top:40px;padding-bottom: 1px;">
    <section class="section innovation-finance-section">
      <div class="innovation-header">
        <div class="innovation-title-wrapper">
          <img src="../assets/img/index/ysj.png" alt="科创金融" class="innovation-icon">
          <div class="innovation-title-group">
            <h2 class="innovation-title">科创金融</h2>
<!--            <p class="innovation-subtitle" style="color: #8EC5FF ;">INNOVATION FINANCE </p>-->
          </div>
        </div>
   
      </div>
      <div class="innovation-content">
        <div class="innovation-main-card">
          <div class="innovation-tabs">
            <span 
              class="tab-item" 
              :class="{ active: activeTab === '技术融资服务' }"
              @click="activeTab = '技术融资服务'"
            >技术融资服务</span>
          <span 
              class="tab-item" 
              :class="{ active: activeTab === '知识产权金融服务' }"
              @click="activeTab = '知识产权金融服务'"
            >知识产权金融服务</span> 
            <span 
              class="tab-item" 
              :class="{ active: activeTab === '金融产品' }"
              @click="activeTab = '金融产品'"
            >金融产品</span>
            <span 
              class="tab-item" 
              :class="{ active: activeTab === '咨询服务' }"
              @click="activeTab = '咨询服务'"
            >咨询服务</span>
          </div>
          <div class="innovation-card-content">
            <!-- 技术融资服务 -->
            <div v-if="activeTab === '技术融资服务'" class="service-list-home">
              <div class="service-item-home">
                <div class="item-number-home">01</div>
                <div class="item-content-home">
                  <h4 class="item-title-home">股权融资</h4>
                  <p class="item-desc-home">对接天使投资、VC/PE机构，开发"技术项目路演-投资意向对接-尽职调查"线上通道。</p>
                </div>
              </div>
              <div class="service-item-home">
                <div class="item-number-home">02</div>
                <div class="item-content-home">
                  <h4 class="item-title-home">债权融资</h4>
                  <p class="item-desc-home">联合国有银行开发"技术贷"产品，以专利、软件著作权等知识产权质押为核心。</p>
                </div>
              </div>
              <div class="service-item-home">
                <div class="item-number-home">03</div>
                <div class="item-content-home">
                  <h4 class="item-title-home">政策性融资</h4>
                  <p class="item-desc-home">整合河南省"科技贷""专精特新贷"等政策资源，设置绿色通道对接国家级资金。</p>
                </div>
              </div>
            </div>

            <!-- 知识产权金融服务 -->
            <div v-if="activeTab === '知识产权金融服务'" class="service-list-home">
              <div class="service-item-home">
                <div class="item-number-home">01</div>
                <div class="item-content-home">
                  <h4 class="item-title-home">知识产权质押</h4>
                  <p class="item-desc-home">通过专利价值动态评估模型提供快速确权、评估、质押全流程服务。</p>
                </div>
              </div>
              <div class="service-item-home">
                <div class="item-number-home">02</div>
                <div class="item-content-home">
                  <h4 class="item-title-home">知识产权保险</h4>
                  <p class="item-desc-home">提供全面的知识产权保险，覆盖技术交易中的法律风险，降低企业维权成本。</p>
                </div>
              </div>
              <div class="service-item-home">
                <div class="item-number-home">03</div>
                <div class="item-content-home">
                  <h4 class="item-title-home">知识产权证券化</h4>
                  <p class="item-desc-home">筛选高价值专利组合发行ABS产品，盘活存量技术资产。</p>
                </div>
              </div>
            </div>

            <!-- 金融产品和咨询服务保持原样 -->
            <div v-if="activeTab === '金融产品' || activeTab === '咨询服务'">
              <h3 class="card-title">{{ tabContents[activeTab].title }}</h3>
              <p class="card-desc">{{ tabContents[activeTab].desc }}</p>
              <button class="card-btn" @click="handleInnovationBtnClick">{{ tabContents[activeTab].btnText }}</button>
            </div>
          </div>
          <div class="innovation-chart">
            <svg width="100%" height="100%" viewBox="0 0 400 120">
              <polyline points="20,80 60,70 100,85 140,60 180,75 220,50 260,65 300,45 340,55 380,40" 
                fill="none" stroke="#3B82F6" stroke-width="2"/>
            </svg>
          </div>
        </div>
        <div class="innovation-side-cards">
          <div class="innovation-card" @click="goToZscqyyfw">
            <div class="card-icon-wrapper">
              <img src="../assets/img/index/dunpai.png" alt="知识产权运营">
            </div>
            <h3 class="side-card-title">知识产权运营</h3>
          </div>
          <div class="innovation-card" @click="goToKjcgzh">
            <div class="card-icon-wrapper green">
              <img src="../assets/img/index/闪电.png" alt="科技成果转化">
            </div>
            <h3 class="side-card-title">科技成果转化</h3>
          </div>
        </div>
      </div>
      
      <!-- 知识图谱检索和交易规则 -->
      <div class="knowledge-rules-section">
        <div class="knowledge-card">
          <div class="knowledge-header">
            <div class="knowledge-title-wrapper">
              <img src="../assets/img/index/fxt.png" alt="知识图谱" class="knowledge-icon">
              <div class="knowledge-title-group">
                <h3 class="knowledge-title">知识图谱检索</h3>
<!--                <p class="knowledge-subtitle">KNOWLEDGE GRAPH</p>-->
              </div>
            </div>
            <a href="javascript:void(0)" @click="goToZstp" class="more-link-small">更多 ></a>
          </div>
          <div class="knowledge-content">
            <div class="knowledge-visual">
              <div class="knowledge-network">
          
     
                <div class="network-center-content">
                  <div class="network-center-text">知识图谱可视化分析</div>
                  <button class="search-btn" @click="goToZstp">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <circle cx="7" cy="7" r="5" stroke="white" stroke-width="1.5"/>
                      <path d="M11 11L14 14" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                    </svg>
                    <span>进入检索</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="rules-card">
          <div class="rules-header">
            <div class="rules-title-wrapper">
              <img src="../assets/img/index/book.png" alt="交易规则" class="rules-icon">
              <div class="rules-title-group">
                <h3 class="rules-title">交易规则</h3>
<!--                <p class="rules-subtitle">RULES</p>-->
              </div>
            </div>
            <a href="javascript:void(0)" @click="goToJygz" class="more-link-small">更多 ></a>
          </div>
          <div class="rules-content">
            <div class="rules-list">
              <div class="rule-item" @click="openRulesDialog">河南科技成果与知识产权交易服务平台 交易规则(试行)</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  
</div>
  </div>
</template>
  
<script>

import { getAction } from '@/api/requests'
import { patentAction } from '@/api/requests'

export default {
  name: 'IndexContent',
  data() {
    return {
      activeTab: '技术融资服务',
      achievementActiveTab: '专利技术',
      achievementTabs: ['专利技术', '科技成果'],
      achievementData: [],
      achievementLoading: false,
      achievementDialogVisible: false,
      achievementDialogTitle: '',
      achievementDetailData: {},
      statsData: [
        { key: 'tech_project', name: '技术项目', value: '1,203', unit: '项' },
        { key: 'deal_project', name: '成交项目', value: '852', unit: '项' },
        { key: 'deal_amount', name: '成交金额', value: '5,648', unit: '万元' }
      ],
      displayStats: [
        { key: 'tech_project', name: '技术项目', value: 0, displayValue: '0', unit: '项' },
        { key: 'deal_project', name: '成交项目', value: 0, displayValue: '0', unit: '项' },
        { key: 'deal_amount', name: '成交金额', value: 0, displayValue: '0', unit: '万元' }
      ],
      rulesDialogVisible: false,
      rulesContent: `
        <div class="chapter-section">
          <h2 class="chapter-title">第一章 总则</h2>
          <p class="article-item"><span class="article-number">第一条</span> 为规范在河南科技成果与知识产权交易服务平台（以下简称"科交平台"）进行的交易行为，保护交易各方的合法权益，维护交易秩序，根据《中华人民共和国促进科技成果转化法》《河南省促进科技成果转化条例》等有关规定，制定本规则。</p>
          <p class="article-item"><span class="article-number">第二条</span> 本规则适用于在科交平台进行的科技成果和知识产权交易，包括科技成果和知识产权的转让、许可、作价入股，技术开发、咨询等服务的购买，以及通过科交平台进行的其他交易行为。</p>
          <p class="article-item"><span class="article-number">第三条</span> 科交平台提供公开挂牌交易、非公开协议交易等进场交易方式。公开挂牌交易是指交易方在履行相关决策或审批程序后，通过科交平台发布交易信息，公开征集意向受让方的进场交易方式，按照受理交易申请、发布交易信息、登记受让意向、组织交易签约、结算交易资金、出具交易凭证等程序进行。非公开协议交易是指交易方在进场前已经达成交易并签订协议，科交平台对交易行为进行鉴证的交易方式。</p>
          <p class="article-item"><span class="article-number">第四条</span> 科交平台按照本规则对交易方提交的各项申请进行形式审核。科交平台不代为履行应当由交易方承担的任何义务，不为交易方提供任何形式的担保。交易方应当自行承担交易风险。</p>
          <p class="article-item"><span class="article-number">第五条</span> 交易方在科交平台从事交易，应当遵守法律法规、政策性文件的规定和科交平台的业务规则，遵循自愿平等、诚实信用和公平公正的原则，不得侵犯他人的合法权益，不得损害社会公共利益。涉及国有科技成果与知识产权交易的，应当符合国资监管规定。</p>
        </div>

        <div class="chapter-section">
          <h2 class="chapter-title">第二章 交易参与方</h2>
          <p class="article-item"><span class="article-number">第六条</span> 本规则所称交易参与方是指具有民事行为能力的自然人、法人或其他组织。交易参与方包括交易方和服务机构。</p>
          <p class="article-item"><span class="article-number">第七条</span> 交易方包括转让方、意向受让方和受让方。转让方是指向科交平台提出交易申请，对科技成果与知识产权拥有处置权的交易方。意向受让方是指向科交平台提出申请，有意向购买转让标的的交易方。受让方是指依法购得转让标的的交易方。</p>
          <p class="article-item"><span class="article-number">第八条</span> 转让方应具备项目所有权及处置权的主体资格，保证拟交易项目权属依法可以交易，并按照国家法律法规和相关政策规定，履行内部决策等相关程序。涉及国有科技成果与知识产权交易的，应当履行必要的审批备案流程。</p>
          <p class="article-item"><span class="article-number">第九条</span> 交易方应当按照科交平台的规定提交交易所需材料，并对所提交材料的真实性、准确性、完整性做出承诺，并承担相应责任。</p>
          <p class="article-item"><span class="article-number">第十条</span> 采取联合转让或联合受让方式的，各方应签订协议，明确各方的权利义务，并推举一方代表联合体各方办理转让或受让相关事宜。</p>
          <p class="article-item"><span class="article-number">第十一条</span> 服务机构是指向科交平台提出申请，经科交平台同意后，在科交平台为交易方提供专业服务的具有合法从业资格的专业机构，包括：（一）金融机构；（二）评估机构；（三）法律机构；（四）知识产权代理机构；（五）其他专业机构。</p>
        </div>

        <div class="chapter-section">
          <h2 class="chapter-title">第三章 公开挂牌交易</h2>
          <h3 class="section-subtitle">第一节 受理登记展示</h3>
          <p class="article-item"><span class="article-number">第十二条</span> 科技成果与知识产权在向科交平台正式申请公开挂牌交易前，可申请登记，进行信息发布展示。</p>
          <p class="article-item"><span class="article-number">第十三条</span> 科技成果与知识产权登记包括初始登记、变更登记、退出登记等。</p>
          <p class="article-item"><span class="article-number">第十四条</span> 初始登记是指科技成果与知识产权在科交平台的首次登记；变更登记是指因科技成果与知识产权信息变更而发生的登记；退出登记是指科技成果与知识产权发生有效期届满、有效期届满前无效或权利被撤销、转让方申请退出等情形时，在科交平台进行退出的登记。</p>
          <p class="article-item"><span class="article-number">第十五条</span> 科技成果与知识产权登记时，转让方应向科交平台提出登记申请，提交登记所需材料，并对所提交材料的真实性、完整性、准确性、有效性、合法性负责，不存在虚假记载、误导性陈述、泄露秘密、侵犯第三人权益等情形。</p>
          <p class="article-item"><span class="article-number">第十六条</span> 科交平台接到转让方的登记申请后，对申请材料进行形式审查，符合条件的在科交平台进行登记并进行信息发布展示。</p>
          <p class="article-item"><span class="article-number">第十七条</span> 科技成果与知识产权发生变更、退出情形的，科交平台对登记情况进行更新。</p>
        </div>

        <div class="chapter-section">
          <h3 class="section-subtitle">第二节 受理转让申请</h3>
          <p class="article-item"><span class="article-number">第十八条</span> 科技成果与知识产权在进场交易时，转让方应向科交平台提出科技成果与知识产权转让申请。申请进场交易之前转让方应按规定履行内部决策、审议程序，办理相关审批手续。</p>
          <p class="article-item"><span class="article-number">第十九条</span> 转让方应当向科交平台提交以下申请材料：（一）交易申请书；（二）转让方主体资格证明文件；（三）转让方内部决策文件或交易批准文件；（四）交易标的权属证明文件；（五）交易标的评估报告或其他定价依据；（六）交易标的涉及共有权或在交易标的上设置他项权利的，应当提供相关权利人同意交易的文件或对权利限制相关安排的说明文件；（七）科交平台要求提交的其他材料。转让方应对所提供材料的真实性、准确性、完整性、有效性、合法性负责，不存在虚假记载、误导性陈述、泄露秘密、侵犯第三人权益或重大遗漏等情形。</p>
        </div>

        <div class="chapter-section">
          <h2 class="chapter-title">第七章 附则</h2>
          <p class="article-item"><span class="article-number">第八十一条</span> 国家法律、法规及政府相关部门对交易有特别规定的，从其规定。</p>
          <p class="article-item"><span class="article-number">第八十二条</span> 本规则由河南省科教创新科技成果转化服务有限公司负责解释和修订。</p>
          <p class="article-item"><span class="article-number">第八十三条</span> 本规则自公布之日起施行。</p>
        </div>
      `,
      slides: [
        require('../assets/img/index/beij.png'),
        require('../assets/img/index/beij.png'),
        require('../assets/img/index/beij.png')
      ],
      tableData: [],
      tabContents: {
        '技术融资服务': {
          title: '技术融资服务',
          desc: '对接天使投资、VC/PE机构，提供股权融资、债权融资等多元化融资服务，助力科技企业快速发展。',
          btnText: '立即申请 >'
        },
        '知识产权金融服务': {
          title: '知识产权金融服务',
          desc: '以专利、软件著作权等知识产权质押为核心，联合金融机构开发创新金融产品，降低企业融资门槛。',
          btnText: '了解详情 >'
        },
        '金融产品': {
          title: '金融产品',
          desc: '提供技术贷、知识产权质押贷款、科技保险等多样化金融产品，满足企业不同阶段的融资需求。',
          btnText: '查看产品 >'
        },
        '咨询服务': {
          title: '咨询服务',
          desc: '全方位的科技金融咨询服务，为企业提供融资规划、政策解读、投融资对接等一站式解决方案。',
          btnText: '咨询 >'
        }
      },
      recommendationIndex: 0,
      recommendationLoading: false,
      intentionList: [],
      intentionLoading: false,
      recommendationProjects: [
        {
          id: 1,
          title: '基于芯片级硅基光子集成芯片设计平台',
          category: '电子信息',
          tag: '转让',
          demandType: '技术转让',
          description: '本项目基于先进的硅基光子集成技术，提供完整的芯片级设计平台解决方案。'
        },
        {
          id: 2,
          title: '智能制造生产线自动化升级改造技术',
          category: '智能制造',
          tag: '许可',
          demandType: '技术许可',
          description: '提供智能制造生产线的全面自动化升级改造解决方案。'
        },
        {
          id: 3,
          title: '新能源汽车动力电池管理系统',
          category: '新能源',
          tag: '转让',
          demandType: '技术转让',
          description: '高效的新能源汽车动力电池管理系统，提升电池使用寿命和安全性。'
        },
        {
          id: 4,
          title: '工业互联网平台关键技术研发',
          category: '工业互联网',
          tag: '合作',
          demandType: '合作开发',
          description: '工业互联网平台的核心技术研发与应用推广。'
        },
        {
          id: 5,
          title: '人工智能图像识别算法优化',
          category: '人工智能',
          tag: '转让',
          demandType: '技术转让',
          description: '基于深度学习的图像识别算法，准确率高达98%以上。'
        },
        {
          id: 6,
          title: '5G通信基站节能降耗技术',
          category: '通信技术',
          tag: '许可',
          demandType: '技术许可',
          description: '创新的5G基站节能技术，降低运营成本30%以上。'
        },
        {
          id: 7,
          title: '生物医药新型药物研发平台',
          category: '生物医药',
          tag: '转让',
          demandType: '技术转让',
          description: '高通量药物筛选平台，加速新药研发进程。'
        },
        {
          id: 8,
          title: '环保水处理膜材料制备技术',
          category: '环保技术',
          tag: '合作',
          demandType: '合作开发',
          description: '新型环保水处理膜材料，处理效率提升50%。'
        }
      ]
    }
  },
  computed: {
    // 特色新闻（前3条用于轮播）
    featuredNews() {
      return this.tableData.slice(0, 3)
    },
    // 普通新闻（剩余的）
    regularNews() {
      return this.tableData.slice(3, 8)
    },
    // 当前显示的推荐项目
    displayedRecommendations() {
      return this.recommendationProjects.slice(this.recommendationIndex, this.recommendationIndex + 4)
    }
  },
  mounted() {
    this.getMediaNews()
    this.getAchievementData()
    this.getStatsData()
    this.getRecommendations()
    this.getIntentionList()
    // 动态注入 rules-dialog 样式
    this.injectRulesDialogStyles()
  },
  watch: {
    achievementActiveTab: {
      handler() {
        this.getAchievementData()
      }
    }
  },
  methods: {
    injectRulesDialogStyles() {
      const style = document.createElement('style')
      style.textContent = `
        /* 交易规则弹窗 */
        .rules-dialog .el-dialog {
          display: flex;
          flex-direction: column;
        }
        .rules-dialog .el-dialog__header {
          background: linear-gradient(135deg, #3B82F6 0%, #2563EB 100%) !important;
          padding: 24px 32px !important;
          border-radius: 16px 16px 0 0 !important;
          margin: 0 !important;
          flex-shrink: 0;
          position: relative;
          z-index: 10;
        }
        .rules-dialog .el-dialog__title {
          color: #FFFFFF !important;
          font-size: 18px !important;
          font-weight: 600 !important;
        }
        .rules-dialog .el-dialog__headerbtn {
          background: rgba(255, 255, 255, 0.2) !important;
          position: absolute;
          top: 24px;
          right: 32px;
          width: 36px;
          height: 36px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 11;
        }
        .rules-dialog .el-dialog__headerbtn:hover {
          background: rgba(255, 255, 255, 0.3) !important;
          transform: scale(1.1);
        }
        .rules-dialog .el-dialog__close {
          color: #FFFFFF !important;
          font-size: 18px !important;
          font-weight: bold !important;
        }
        .rules-dialog .el-dialog__body {
          flex: 1;
          overflow-y: auto;
          padding: 32px;
          max-height: 600px;
        }
        
        /* 成果展示弹窗 */
        .custom-dialog .el-dialog {
          display: flex;
          flex-direction: column;
        }
        .custom-dialog .el-dialog__header {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
          padding: 24px 32px !important;
          border-radius: 16px 16px 0 0 !important;
          margin: 0 !important;
          flex-shrink: 0;
          position: relative;
          z-index: 10;
        }
        .custom-dialog .el-dialog__title {
          color: #FFFFFF !important;
          font-size: 20px !important;
          font-weight: 600 !important;
        }
        .custom-dialog .el-dialog__headerbtn {
          background: rgba(255, 255, 255, 0.2) !important;
          position: absolute;
          top: 24px;
          right: 32px;
          width: 36px;
          height: 36px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 11;
          transition: all 0.3s;
        }
        .custom-dialog .el-dialog__headerbtn:hover {
          background: rgba(255, 255, 255, 0.3) !important;
          transform: scale(1.1);
        }
        .custom-dialog .el-dialog__close {
          color: #FFFFFF !important;
          font-size: 18px !important;
          font-weight: bold !important;
          position: static;
          top: auto;
          right: auto;
        }
        .custom-dialog .el-dialog__body {
          flex: 1;
          overflow-y: auto;
          padding: 32px;
          max-height: 600px;
        }
      `
      document.head.appendChild(style)
    },
    goToMtzx() {
      // 通过事件通知父组件切换 tab
      this.$emit('switchTab', '6')
    },
    handleNewsClick(row) {
      this.$router.push({
        path: '/mtzx-detail',
        query: {
          id: row.id,
          title: row.title,
          content: row.content,
          publishTime: row.publishTime,
          publishUnit: row.publishUnit,
          img: row.img,
          linkUrl: row.linkUrl
        }
      })
    },
    stripHtml(str = '') {
      return new DOMParser()
        .parseFromString(str, 'text/html')
        .body.textContent || '';
    },
    getRecommendations() {
      this.recommendationLoading = true
      getAction('/trade/hall/list', { recommendFlag: 1 }).then(res => {
        const statusMapReverse = {
          'listing': '挂牌中',
          'applying': '报名中',
          'bidding': '竞价中',
          'dealed': '已成交',
          'terminated': '已终止'
        }
        const typeMapReverse = {
          'transfer': '转让',
          'license': '许可',
          'equity': '作价入股',
          'open_license': '开放许可'
        }
        const rows = res.rows || res.data || []
        if (rows.length > 0) {
          this.recommendationProjects = rows.map(item => ({
            id: item.id,
            sourceType: item.sourceType || 'formal',
            title: item.projectName || item.demandName || '',
            category: statusMapReverse[item.projectStatus] || item.projectStatus || '',
            tag: typeMapReverse[item.projectType] || item.projectType || '转让',
            demandType: item.demandType || '',
            description: item.demandDescription || item.description || '',
            contactPerson: item.contactPerson || '',
            contactInfo: item.contactInfo || '',
            createTime: item.createTime || '',
            img: item.coverImage ? '/prod-api' + item.coverImage : ''
          }))
        }
        this.recommendationLoading = false
      }).catch(() => {
        this.recommendationLoading = false
      })
    },
    getStatsData() {
      getAction('/portal/data-config').then(res => {
        const list = res.data || []
        if (list.length > 0) {
          this.statsData = list.map(item => ({
            key: item.key,
            name: item.name,
            value: item.value,
            unit: item.unit
          }))
          this.displayStats = this.statsData.map(item => ({
            ...item,
            displayValue: '0'
          }))
          this.$nextTick(() => {
            this.animateStats()
          })
        }
      }).catch(() => {})
    },
    animateStats() {
      const duration = 1500 // 动画时长 ms
      const steps = 60
      const interval = duration / steps
      this.displayStats.forEach((item, index) => {
        const target = parseFloat(String(item.value).replace(/,/g, '')) || 0
        let current = 0
        let step = 0
        const timer = setInterval(() => {
          step++
          // easeOutQuad 缓动
          const progress = 1 - Math.pow(1 - step / steps, 2)
          current = Math.floor(target * progress)
          // 格式化数字（超过999加逗号）
          this.displayStats[index].displayValue = current >= 1000
            ? current.toLocaleString('en-US')
            : String(current)
          if (step >= steps) {
            this.displayStats[index].displayValue = target >= 1000
              ? target.toLocaleString('en-US')
              : String(target)
            clearInterval(timer)
          }
        }, interval)
      })
    },
    getMediaNews() {
      let data = {
        pageNum: 1,
        pageSize: 8,
        type: 2,
        publishStatus: 1
      }
      getAction("/cms/news/list", data).then(res => {
        this.tableData = (res.rows || []).map(item => ({
          ...item,
          coverImage: item.coverImage ? '/prod-api' + item.coverImage : ''
        }))
      })
    },
    getAchievementData() {
      this.achievementLoading = true
      if (this.achievementActiveTab === '专利技术') {
        this.getPatentData()
      } else if (this.achievementActiveTab === '科技成果') {
        this.getScienceData()
      }
    },
    getPatentData() {
      let data = {
        pageNum: 1,
        pageSize: 5
      }
      patentAction("/zscq/patent/list", data).then(res => {
        this.achievementData = res.rows ? res.rows.slice(0, 5) : []
        this.achievementLoading = false
        console.log(res)
      }).catch(() => {
        this.achievementLoading = false
      })
    },
    getScienceData() {
      let data = {
        pageNum: 1,
        pageSize: 5
      }
      getAction("/edu/declaration/list", data).then(res => {
        this.achievementData = res.rows ? res.rows.slice(0, 5) : []
        this.achievementLoading = false
        console.log(res)
      }).catch(() => {
        this.achievementLoading = false
      })
    },
    goToSjzy() {
      // 通过事件通知父组件切换到数据资源页面，并传递当前选中的tab
      this.$emit('switchTab', '3', this.achievementActiveTab)
    },
    getIntentionList() {
      this.intentionLoading = true
      getAction('/trade/hall/list', { sourceType: 'intention', pageNum: 1, pageSize: 5 }).then(res => {
        this.intentionList = (res.rows || []).map(item => ({
          id: item.id,
          sourceType: item.sourceType,
          projectName: item.projectName || item.name || '',
          industryType: item.industryType || '',
          listingPrice: item.listingPrice || ''
        }))
        this.intentionLoading = false
      }).catch(() => {
        this.intentionLoading = false
      })
    },
    goToJydt() {
      this.$emit('switchTab', '9', '意向挂牌')
    },
    goToRecommendation() {
      // 通过事件通知父组件切换到交易大厅页面
      this.$emit('switchTab', '9')
    },
    goToZscqyyfw() {
      // 通过事件通知父组件切换到知识产权运营服务页面
      this.$emit('switchTab', '10')
    },
    goToKjcgzh() {
      // 通过事件通知父组件切换到科技成果转化页面
      this.$emit('switchTab', '11')
    },
    goToZstp() {
      // 通过事件通知父组件切换到知识图谱页面
      this.$emit('switchTab', '15')
    },
    goToJygz() {
      // 通过事件通知父组件切换到交易规则页面
      this.$emit('switchTab', '8')
    },
    goToProjectDetail(item) {
      this.$router.push({
        path: '/jydt-detail',
        query: {
          id: item.id,
          sourceType: item.sourceType || 'formal'
        }
      })
    },
    prevRecommendation() {
      if (this.recommendationIndex > 0) {
        this.recommendationIndex--
      }
    },
    nextRecommendation() {
      if (this.recommendationIndex < this.recommendationProjects.length - 4) {
        this.recommendationIndex++
      }
    },
    handleInnovationBtnClick() {
      // 根据不同的tab切换到科创金融页面
      if (this.activeTab === '咨询服务') {
        this.$emit('switchTab', '12')
      } else if (this.activeTab === '金融产品') {
        this.$emit('switchTab', '12', '金融产品')
      } else {
        // 其他tab也切换到科创金融页面
        this.$emit('switchTab', '12')
      }
    },
    handleAchievementClick(item) {
      // 打开弹窗显示详情
      if (this.achievementActiveTab === '专利技术') {
        this.achievementDetailData = item
        this.achievementDialogTitle = '专利技术详情'
        this.achievementDialogVisible = true
      } else if (this.achievementActiveTab === '科技成果') {
        // 科技成果需要调用接口获取详情
        if(item.opType == null || item.opType == 1){
          getAction("/edu/declaration/" + item.id).then(res => {
            this.achievementDetailData = res.data
            this.achievementDialogTitle = '科技成果详情'
            this.achievementDialogVisible = true
          })
        } else {
          this.achievementDetailData = item
          this.achievementDialogTitle = '科技成果详情'
          this.achievementDialogVisible = true
        }
      }
    },
    handleAchievementDialogClose() {
      this.achievementDialogVisible = false
      this.achievementDetailData = {}
    },
    openRulesDialog() {
      this.rulesDialogVisible = true
    },
    handleRulesDialogClose() {
      this.rulesDialogVisible = false
    }
  }
}
</script>
  
<style scoped>

/* 自定义弹窗样式 - 使用更具体的选择器 */
:deep(.custom-dialog) {
  border-radius: 16px !important;
}

:deep(.custom-dialog .el-dialog__header) {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  padding: 24px 32px !important;
  border-radius: 16px 16px 0 0 !important;
  margin: 0 !important;
}
:deep(.custom-dialog .el-dialog__title) {
  font-size: 20px !important;
  font-weight: 600 !important;
  color: #FFFFFF !important;
  position: relative !important;
  display: inline-block !important;
  padding: 8px 20px !important;
  background: rgba(255, 255, 255, 0.2) !important;
  border-radius: 12px !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
}
:deep(.custom-dialog .el-dialog__headerbtn) {
  width: 36px;
  height: 36px;
  top: 24px;
  right: 32px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
}

:deep(.custom-dialog .el-dialog__headerbtn:hover) {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.1);
}

:deep(.custom-dialog .el-dialog__headerbtn .el-dialog__close) {
  color: #FFFFFF;
  font-size: 18px;
  font-weight: bold;
  position: static;
  top: auto;
  right: auto;
}

:deep(.custom-dialog .el-dialog__headerbtn:hover .el-dialog__close) {
  color: #FFFFFF;
}

:deep(.custom-dialog .el-dialog__body) {
  padding: 32px;
  max-height: 600px;
  overflow-y: auto;
}

/* 详情内容样式 */
.dialog-content {
  width: 100%;
}

.detail-section {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.detail-item {
  display: flex;
  align-items: flex-start;
  padding: 16px;
  background: #F9FAFB;
  border-radius: 8px;
  border-left: 3px solid #3B82F6;
  transition: all 0.3s;
}

.detail-item:hover {
  background: #F3F4F6;
  border-left-color: #2563EB;
}

.detail-label {
  min-width: 100px;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  flex-shrink: 0;
}

.detail-value {
  flex: 1;
  font-size: 14px;
  color: #6B7280;
  line-height: 1.6;
  word-break: break-word;
}

.contact-info {
  background: linear-gradient(135deg, #EFF6FF 0%, #DBEAFE 100%);
  border-left-color: #3B82F6;
}

.contact-info .detail-label {
  color: #1E40AF;
}

.contact-info .detail-value {
  color: #1E3A8A;
  font-weight: 500;
}

/* 滚动条样式 */
:deep(.el-dialog__body)::-webkit-scrollbar {
  width: 6px;
}

:deep(.el-dialog__body)::-webkit-scrollbar-track {
  background: #F3F4F6;
  border-radius: 3px;
}

:deep(.el-dialog__body)::-webkit-scrollbar-thumb {
  background: #D1D5DB;
  border-radius: 3px;
}

:deep(.el-dialog__body)::-webkit-scrollbar-thumb:hover {
  background: #9CA3AF;
}

/* 交易规则弹窗样式 */
:deep(.rules-dialog) {
  border-radius: 16px !important;
}

:deep(.rules-dialog .el-dialog__header) {
  background: linear-gradient(135deg, #3B82F6 0%, #2563EB 100%) !important;
  padding: 24px 32px !important;
  border-radius: 16px 16px 0 0 !important;
  margin: 0 !important;
}

:deep(.rules-dialog .el-dialog__title) {
  font-size: 18px !important;
  font-weight: 600 !important;
  color: #FFFFFF !important;
}

:deep(.rules-dialog .el-dialog__headerbtn) {
  width: 36px;
  height: 36px;
  top: 24px;
  right: 32px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
}

:deep(.rules-dialog .el-dialog__headerbtn:hover) {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.1);
}

:deep(.rules-dialog .el-dialog__headerbtn .el-dialog__close) {
  color: #FFFFFF;
  font-size: 18px;
  font-weight: bold;
  position: static;
  top: auto;
  right: auto;
}

:deep(.rules-dialog .el-dialog__body) {
  padding: 32px;
  max-height: 600px;
  overflow-y: auto;
}

:deep(.rules-dialog .dialog-content) {
  color: #374151;
  font-size: 14px;
  line-height: 2;
  padding: 20px 0;
}

/* 媒体中心 */
.media-center {
  background: #FFFFFF;
  box-shadow: 0px 1px 2px -1px rgba(0, 0, 0, 0.1), 0px 1px 3px 0px rgba(0, 0, 0, 0.1);
  border-radius: 16px 16px 16px 16px;
  border: 1px solid #f0f0f0;
  padding: 30px;
}

.achievement-section {
  background: #FFFFFF;
  box-shadow: 0px 1px 2px -1px rgba(0, 0, 0, 0.1), 0px 1px 3px 0px rgba(0, 0, 0, 0.1);
  border-radius: 16px 16px 16px 16px;
  border: 1px solid #f0f0f0;
  padding: 30px;
  position: relative;
  min-height: 400px;
}

.intention-section {
  background: #FFFFFF;
  box-shadow: 0px 1px 2px -1px rgba(0, 0, 0, 0.1), 0px 1px 3px 0px rgba(0, 0, 0, 0.1);
  border-radius: 16px 16px 16px 16px;
  border: 1px solid #f0f0f0;
  padding: 30px;
}

.intention-list {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.intention-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background-color 0.3s;
}

.intention-item:last-child {
  border-bottom: none;
}

.intention-item:hover {
  background-color: #f9f9f9;
}

.intention-content {
  flex: 1;
}

.intention-title {
  font-size: 14px;
  font-weight: 500;
  color: #333333;
  margin: 0 0 8px 0;
}

.intention-desc {
  font-size: 12px;
  color: #999999;
  margin: 0;
}

.intention-price {
  font-size: 14px;
  font-weight: 600;
  color: #ff4444;
  white-space: nowrap;
  margin-left: 20px;
}

.media-title-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.media-title-group h2 {
  font-size: 24px;
  font-weight: 600;
  color: #1a202c;
  margin: 0;
}

.media-subtitle {
  font-size: 12px;
  color: #a0aec0;
  margin: 0;
  font-weight: 400;
}

.media-box {
  display: flex;
  gap: 40px;
  align-items: flex-start;
}

.media-video {
  position: relative;
  width: 764px !important;
  flex-shrink: 0;
  border-radius: 0px;
  overflow: visible;
}

/* 轮播图样式 - 参照 mtzx.vue */
:deep(.el-carousel) {
  border-radius: 12px;
  overflow: visible;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

:deep(.el-carousel__container) {
  height: 320px;
  border-radius: 12px;
  overflow: hidden;
}

:deep(.el-carousel__arrow) {
  background-color: rgba(255, 255, 255, 0.9);
  color: #3B82F6;
  width: 48px;
  height: 48px;
  font-size: 20px;
  border-radius: 50%;
  transition: all 0.3s;
}

:deep(.el-carousel__arrow:hover) {
  background-color: #3B82F6;
  color: #FFFFFF;
  transform: scale(1.1);
}

:deep(.el-carousel__arrow--left) {
  left: 20px;
}

:deep(.el-carousel__arrow--right) {
  right: 20px;
}

:deep(.el-carousel__indicators) {
  margin-top: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 20px;
}

:deep(.el-carousel__indicator) {
  padding: 8px 4px;
  display: flex;
  align-items: center;
}

:deep(.el-carousel__button) {
  width: 32px;
  height: 4px;
  border-radius: 2px;
  background-color: #D1D5DB;
  opacity: 1;
  transition: all 0.3s;
}

:deep(.el-carousel__indicator.is-active .el-carousel__button) {
  background-color: #3B82F6;
  width: 48px;
}

:deep(.el-carousel__indicator:hover .el-carousel__button) {
  background-color: #93C5FD;
}

.media-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.media-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 764px !important;
  height: 320px !important;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.9) 0%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0) 100%);
  border-radius: 0px 0px 0px 0px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  color: white;
  justify-content: flex-end;
}

.media-tag {
  display: inline-block;
  background: #2563EB ;
  color: white;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
  width: fit-content;
}

.media-title {
  font-size: 16px;
  font-weight: 600;
  color: white;
}

.media-date {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.8);
}

.media-list {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0;
  padding-left: 0;
}

.media-section-title {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 30px;
}

.title-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.title-icon-box {
  font-size: 24px;
  color: #64748B ;
  flex-shrink: 0;
}

.media-item {
  display: flex !important;
  align-items: center !important;
  gap: 12px !important;
  padding: 16px 0 !important;
  border-bottom: none !important;
  cursor: pointer !important;
  transition: all 0.3s ease !important;
}

.media-item:hover {
  background-color: #f9f9f9 !important;
  padding-left: 8px !important;
  padding-right: 8px !important;
  margin-left: -8px !important;
  margin-right: -8px !important;
  border-radius: 8px !important;
}

.media-item:last-child {
  border-bottom: none !important;
}

.media-item-bullet {
  color: #d0d0d0 !important;
  font-size: 8px !important;
  font-weight: bold !important;
  flex-shrink: 0 !important;
  width: 6px !important;
  height: 6px !important;
  border-radius: 50% !important;
  background: #d0d0d0 !important;
  line-height: 1 !important;
}

.media-item-title {
  flex: 1 !important;
  min-width: 0 !important;
  max-width: 330px !important;
  font-size: 14px !important;
  color: #666666 !important;
  line-height: 1.6 !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

.media-item-date {
  font-size: 12px !important;
  color: #cccccc !important;
  white-space: nowrap !important;
  flex-shrink: 0 !important;
  margin-left: 0 !important;
}


.media-more {
  padding-top: 16px;
  text-align: right;
}

.media-more-link {
  color: #64748B ;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.3s;
}

.media-more-link:hover {
  color: #64748B ;
}

/* 顶部空白 */
.header-space {
  height: 80px;
  background-color: #19243e;
}

/* 主横幅区域 */
.banner {
  width: 100%;
  background-image: url('../assets/img/index/beij.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-color: #19243e;
  padding: 80px 0 100px;
  text-align: center;
  color: white;
}

.banner-title-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-bottom: 40px;
  flex-wrap: wrap;
}

.banner-title-part1 {
  font-family: Inter, Inter;
  font-weight: bold;
  font-size: 60px;
  color: #FFFFFF;
  line-height: 60px;
  text-align: center;
  font-style: normal;
  text-transform: none;
}

.banner-title-part2 {
  font-family: Inter, Inter;
  font-weight: bold;
  font-size: 60px;
  color: rgba(0, 0, 0, 0);
  line-height: 60px;
  text-align: center;
  font-style: normal;
  text-transform: none;
  background: linear-gradient(0deg, #8EC5FF 0%, #A3B3FF 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.banner-title-part3 {
  font-family: Inter, Inter;
  font-weight: bold;
  font-size: 60px;
  color: #FFFFFF;
  line-height: 60px;
  text-align: center;
  font-style: normal;
  text-transform: none;
}

.banner-subtitle {
  font-family: Inter, Inter;
  font-weight: 300;
  font-size: 20px;
  color: #E2E8F0;
  line-height: 28px;
  text-align: center;
  font-style: normal;
  text-transform: none;
  margin-bottom: 40px;
}

.banner-buttons {
  display: flex;
  gap: 30px;
  justify-content: center;
  margin-bottom: 80px;
}

.btn {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 32px;
  font-size: 16px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.3s ease;
  text-decoration: none;
}

.btn-icon {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.btn-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
}

.btn-title {
  font-size: 16px;
  font-weight: 600;
  color: white;
}

.btn-subtitle {
  font-size: 10px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.8);
}

.btn-arrow {
  width: 32px;
  height: 32px;
  object-fit: contain;
  margin-left: 8px;
}

.btn-primary {
background: linear-gradient( 90deg, #155DFC 0%, #2B7FFF 100%);
  color: white;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 16px rgba(53, 132, 213, 0.4);
}

.btn-secondary {
  background: linear-gradient(135deg, #7C3AED 0%, #3B82F6 100%);
  color: white;
}

.btn-secondary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 16px rgba(124, 58, 237, 0.4);
}

.stats-container {
  display: flex;
  justify-content: center;
  gap: 60px;
  margin-top: 60px;
  width: 1200px;
  height: 151px;
  background: rgba(15, 23, 43, 0.6);
  box-shadow: 0px 25px 50px -12px rgba(0, 0, 0, 0.25), 0px 0px 0px 1px rgba(255, 255, 255, 0.05);
  border-radius: 16px;
  border: 2px solid rgba(255, 255, 255, 0.1);
  margin-left: auto;
  margin-right: auto;
  align-items: center;
}

.stat-item {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  flex: 1;
}

.stat-label {
  font-size: 14px;
  color: #a0aec0;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 6px;
  justify-content: center;
}

.stat-label::before {
  content: '';
  display: inline-block;
  width: 16px;
  height: 16px;
  background-size: contain;
  background-repeat: no-repeat;
}

.stat-item:nth-child(1) .stat-label::before {
  background-image: url('../assets/img/index/wd1.png');
}

.stat-item:nth-child(2) .stat-label::before {
  background-image: url('../assets/img/index/dh.png');
}

.stat-item:nth-child(3) .stat-label::before {
  background-image: url('../assets/img/index/ss.png');
}

.stat-number {
  font-size: 48px;
  font-weight: 700;
  color: #FFFFFF;
  margin: 0;
}

.stat-unit {
  font-size: 24px;
  margin-left: 4px;
}

/* 主内容区域 */
.main-content {
  width: 100%;
  background-color: #F1F5F9 ;
}

.section {
  max-width: 1200px;
  margin: 0 auto 60px;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 30px;
  position: relative;
}

.title-icon {
  color: #64748B ;
  font-size: 20px;
}

.section-title h2 {
  font-size: 24px;
  font-weight: 600;
  color: #1a202c;
  margin: 0;
  flex: 1;
}

.more-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 36px;
  border-radius: 37282700px;
  border: 1px solid #E2E8F0;
  color: #64748B ;
  text-decoration: none;
  font-size: 14px;
  background: #FFFFFF;
  transition: all 0.3s;
}

.more-link:hover {
  color: #2563C0;
  border-color: #64748B ;
  background: #f5f9ff;
}

/* 平台介绍 */
.platform-intro {
  background: white;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.intro-box {
  display: flex;
  gap: 40px;
  align-items: flex-start;
}

.intro-image {
  width: 350px;
  height: 220px;
  object-fit: cover;
  border-radius: 4px;
  flex-shrink: 0;
}

.intro-text {
  flex: 1;
  padding-top: 10px;
}

.intro-text p {
  font-size: 15px;
  line-height: 1.8;
  color: #4a5568;
  margin: 0 0 15px 0;
}

.read-more {
  color: #64748B ;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.3s;
}

.read-more:hover {
  color: #2563C0;
}

/* 成果展示 */
/* 成果展示 tab */
.achievement-tabs {
  display: flex;
  gap: 4px;

  padding-bottom: 0;
  border-bottom: none;
}

.achievement-tab-item {
  padding: 12px 28px;
  font-size: 15px;
  font-weight: 500;
  color: #64748B;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 8px 8px 0 0;
  white-space: nowrap;
  position: relative;
  background: #F8FAFC;
  border: 1px solid #E2E8F0;
  border-bottom: none;
}

.achievement-tab-item::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 2px;
  background: transparent;
  transition: background 0.3s;
}

.achievement-tab-item:hover {
  color: #3B82F6;

  border-color: #93C5FD;
}

.achievement-tab-active {
  background: #3B82F6;
  color: #FFFFFF !important;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.25);
  border-color: #3B82F6;
  transform: translateY(-2px);
}

.achievement-tab-active::after {
  background: #3B82F6;
}

.achievement-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  border: 1px solid #E5E7EB;
  padding: 8px;
}

.achievement-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 20px;
  background: white;
  border: 1px solid #F1F5F9;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.achievement-item::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: #3B82F6;
  transform: scaleY(0);
  transition: transform 0.3s ease;
}

.achievement-item:hover {
  background: #F8FAFC;
  border-color: #93C5FD;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.1);
  transform: translateX(4px);
}

.achievement-item:hover::before {
  transform: scaleY(1);
}

.achievement-content {
  flex: 1;
  min-width: 0;
}

.achievement-title {
  font-size: 15px;
  font-weight: 600;
  color: #1E293B;
  margin: 0 0 8px 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 600px;
}

.achievement-desc {
  font-size: 13px;
  color: #94A3B8;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 6px;
}

.achievement-desc::before {
  content: '●';
  font-size: 8px;
  color: #CBD5E1;
}

.achievement-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 20px;
  background: linear-gradient(135deg, #EFF6FF 0%, #DBEAFE 100%);
  color: #3B82F6;
  text-decoration: none;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap;
  margin-left: 20px;
  border: 1px solid #BFDBFE;
}

.achievement-link:hover {
  background: linear-gradient(135deg, #3B82F6 0%, #2563EB 100%);
  color: #FFFFFF;
  border-color: #3B82F6;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
  transform: translateY(-1px);
}

/* 知识产权 */
.ip-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 15px;
}

.ip-item {
  background: white;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s;
  cursor: pointer;
}

.ip-item:hover {
  transform: translateY(-4px);
}

.ip-item img {
  width: 100%;
  height: 100px;
  object-fit: cover;
}

.ip-item p {
  padding: 10px;
  font-size: 12px;
  color: #2d3748;
  text-align: center;
  margin: 0;
}

/* 推荐项目 */
.recommendation-section {
  background: #FFFFFF;
  box-shadow: 0px 1px 2px -1px rgba(0, 0, 0, 0.1), 0px 1px 3px 0px rgba(0, 0, 0, 0.1);
  border-radius: 16px 16px 16px 16px;
  border: 1px solid #f0f0f0;
  padding: 30px;
}

/* 轮播容器 */
.recommendation-carousel-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  margin-top: 30px;
  padding: 0 68px; /* 为绝对定位的箭头留出空间 */
}

/* 轮播箭头 */
.carousel-arrow {
  position: absolute;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 2px solid #E5E7EB;
  background: #FFFFFF;
  color: #6B7280;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
  z-index: 10;
}

.carousel-arrow:hover:not(:disabled) {
  border-color: #3B82F6;
  background: #EFF6FF;
  color: #3B82F6;
  transform: scale(1.1);
}

.carousel-arrow:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.carousel-arrow-left {
  left: 0;
}

.carousel-arrow-right {
  right: 0;
}

.recommendation-grid {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.recommendation-item {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s, box-shadow 0.3s;
  cursor: pointer;
}

.recommendation-item:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
}

.recommendation-image {
  position: relative;
  width: 100%;
  height: 160px;
  overflow: hidden;
}

.recommendation-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.recommendation-tag {
  position: absolute;
  top: 8px;
  right: 8px;
  background: #2563EB;
  color: white;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
}

.recommendation-info {
  padding: 16px;
}

.recommendation-title {
  font-size: 14px;
  font-weight: 600;
  color: #333333;
  margin: 0 0 12px 0;
  line-height: 1.5;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.recommendation-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.recommendation-category {
  font-size: 12px;
  color: #999999;
  margin: 0;
}

.recommendation-link {
  display: inline-block;
  color: #3584D5;
  font-size: 12px;
  transition: color 0.3s;
  cursor: pointer;
}

.recommendation-link:hover {
  color: #2563C0;
}

/* 特色产业 */
.featured-section {
  background: transparent;
  box-shadow: none;
  border: none;
  padding: 0;
    max-width: 1350px;
}

.featured-header {
  text-align: center;
  margin-bottom: 40px;
}

.featured-subtitle {
  font-size: 12px;
  color: #a0aec0;
  margin: 0 0 8px 0;
  font-weight: 400;
}

.featured-title {
  font-size: 28px;
  font-weight: 600;
  color: #1a202c;
  margin: 0;
}

.featured-grid {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.featured-row {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.featured-item {
  position: relative;
  width: 328px;
  aspect-ratio: 328/158;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  flex-shrink: 0;
  transition: transform 0.3s ease;
  text-decoration: none;
  display: block;
}

.featured-item:hover {
  transform: scale(1.02);
}

.featured-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.featured-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.6) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
}

.featured-text-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.featured-text {
  font-size: 16px;
  font-weight: 600;
  color: white;
  margin: 0;
  text-align: center;
}

.featured-underline {
  width: 40px;
  height: 3px;
  background: #3584D5;
  border-radius: 2px;
}

/* 新闻动态 */
.news-list {
  background: white;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.news-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 30px;
  border-bottom: 1px solid #e2e8f0;
  transition: background-color 0.3s;
  cursor: pointer;
}

.news-item:last-child {
  border-bottom: none;
}

.news-item:hover {
  background-color: #f7fafc;
}

.news-title {
  flex: 1;
  font-size: 15px;
  color: #2d3748;
}

.news-arrow {
  color: #cbd5e0;
  font-size: 16px;
  margin-left: 20px;
}

/* 合作伙伴 */
.partners-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.partner-item {
  background: white;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  aspect-ratio: 1.2;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.partner-item img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* 科创金融&成果转化 */
.innovation-finance-section {
  background: transparent;
  box-shadow: none;
  border: none;
  padding: 0;
  max-width: 1350px;
  margin: 60px auto;
}

.innovation-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.innovation-title-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
}

.innovation-icon {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.innovation-title-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.innovation-title {
  font-size: 24px;
  font-weight: 600;
  color: #1a202c;
  margin: 0;
}

.innovation-subtitle {
  font-size: 12px;
  color: #a0aec0;
  margin: 0;
  font-weight: 400;
}

.innovation-content {
  display: flex;
  gap: 20px;
  align-items: stretch;
}

.innovation-main-card {
  width: 762px;
  height: 313px;
  background: #0F172A;
  box-shadow: 0px 25px 50px -12px rgba(0,0,0,0.25);
  border-radius: 14px 14px 14px 14px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 30px;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.innovation-tabs {
  display: flex;
  gap: 20px;
  margin-bottom: 30px;
}

.tab-item {
  font-size: 14px;
  color: #64748B;
  cursor: pointer;
  padding: 8px 0;
  transition: color 0.3s;
  position: relative;
}

.tab-item.active {
  color: #3B82F6;
}

.tab-item.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: #3B82F6;
}

.tab-item:hover {
  color: #3B82F6;
}

.innovation-card-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  z-index: 2;
}

/* 首页服务列表样式 */
.service-list-home {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

.service-item-home {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

.item-number-home {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 700;
  color: #FFFFFF;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.item-content-home {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.item-title-home {
  font-size: 16px;
  font-weight: 600;
  color: #FFFFFF;
  margin: 0;
}

.item-desc-home {
  font-size: 13px;
  color: #CBD5E1;
  line-height: 1.6;
  margin: 0;
}

.card-title {
  font-size: 24px;
  font-weight: 600;
  color: #FFFFFF;
  margin: 0;
}

.card-desc {
  font-size: 14px;
  color: #94A3B8;
  line-height: 1.6;
  margin: 0;
  max-width: 400px;
}

.card-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 24px;
  background: #3B82F6;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
  width: fit-content;
}

.card-btn:hover {
  background: #2563EB;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4);
}

.innovation-chart {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 400px;
  height: 120px;
  opacity: 0.6;
}

.innovation-side-cards {
  display: flex;
  gap: 20px;
}

.innovation-card {
  width: 204px;
  height: 313px;
  background: linear-gradient(135deg, #0F172A 0%, #1E293B 100%);
  border-radius: 16px;
  padding: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.3s;
}

.innovation-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at center, rgba(59, 130, 246, 0.1) 0%, transparent 70%);
  opacity: 0;
  transition: opacity 0.3s;
}

.innovation-card:hover {
  transform: translateY(-4px);
}

.innovation-card:hover::before {
  opacity: 1;
}



.card-icon-wrapper img {
  width: 48px;
  height: 48px;
  object-fit: contain;
}



.card-icon-wrapper::after {
  content: '';
  position: absolute;
  inset: -2px;
  background: linear-gradient(135deg, #3B82F6, #8B5CF6);
  border-radius: 12px;
  z-index: -1;
  opacity: 0.3;
}

.card-icon-wrapper.green::after {
  background: linear-gradient(135deg, #10B981, #3B82F6);
}

.side-card-title {
  font-size: 18px;
  font-weight: 600;
  color: #FFFFFF;
  margin: 0;
  text-align: center;
}

.side-card-title {
  font-size: 18px;
  font-weight: 600;
  color: #FFFFFF;
  margin: 0;
  text-align: center;
}

/* 知识图谱检索和交易规则 */
.knowledge-rules-section {
  display: flex;
  gap: 20px;
  margin-top: 30px;
}

.knowledge-card,
.rules-card {
  flex: 1;
  background: #FFFFFF;
  box-shadow: 0px 1px 2px -1px rgba(0, 0, 0, 0.1), 0px 1px 3px 0px rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  border: 1px solid #f0f0f0;
  padding: 24px;
  height: 250px;
  overflow: hidden;
}


.knowledge-header,
.rules-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.knowledge-title-wrapper,
.rules-title-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
}

.knowledge-icon,
.rules-icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

.knowledge-title-group,
.rules-title-group {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.knowledge-title,
.rules-title {
  font-size: 18px;
  font-weight: 600;
  color: #1a202c;
  margin: 0;
}

.knowledge-subtitle,
.rules-subtitle {
  font-size: 10px;
  color: #a0aec0;
  margin: 0;
  font-weight: 400;
}

.more-link-small {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px 12px;
  border-radius: 37282700px;
  border: 1px solid #E2E8F0;
  color: #64748B;
  text-decoration: none;
  font-size: 12px;
  background: #FFFFFF;
  transition: all 0.3s;
}

.more-link-small:hover {
  color: #2563C0;
  border-color: #64748B;
  background: #f5f9ff;
}

.knowledge-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 0;
  height: calc(100% - 60px);
}

.knowledge-visual {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.knowledge-network {
  position: relative;
  width: 100%;
  flex: 1;
  background-image: url('../assets/img/index/fMp7zepWi.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 120px;
  border-radius: 8px;
}

.network-lines {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.network-node {
  position: absolute;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(59, 130, 246, 0.2);
  border: 2px solid #3B82F6;
}

.network-node.top-left {
  top: 20%;
  left: 15%;
}

.network-node.top-right {
  top: 20%;
  right: 15%;
}

.network-node.bottom-left {
  bottom: 20%;
  left: 15%;
}

.network-node.bottom-right {
  bottom: 20%;
  right: 15%;
}

.network-center-content {
  position: relative;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.network-center-text {
  color: #FFFFFF;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
}

.search-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 320px;
  height: 36px;
  background: rgba(21, 93, 252, 0.8);
  border-radius: 35173300px 35173300px 35173300px 35173300px;
  color: white;
  border: none;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.search-btn:hover {
  background: rgba(21, 93, 252, 1);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(59, 130, 246, 0.5);
}

.rules-content {

}

.rules-list {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.rule-item {
  padding: 14px 0;
  font-size: 14px;
  color: #666666;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: all 0.3s;
  position: relative;
  padding-left: 16px;
}

.rule-item:last-child {
  border-bottom: none;
}

.rule-item::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #d0d0d0;
}

.rule-item:hover {
  color: #3B82F6;
  padding-left: 20px;
}

.rule-item:hover::before {
  background: #3B82F6;
}

/* 底部信息区块 */
.bottom-info {
  background: white;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}

.info-box {
  text-align: center;
  padding: 20px;
}

.info-box img {
  width: 100%;
  height: 180px;
  object-fit: cover;
  border-radius: 4px;
  margin-bottom: 15px;
}

.info-box h3 {
  font-size: 16px;
  font-weight: 600;
  color: #1a202c;
  margin: 0 0 10px 0;
}

.info-box p {
  font-size: 14px;
  color: #4a5568;
  margin: 0;
  line-height: 1.6;
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .gallery-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .ip-grid {
    grid-template-columns: repeat(4, 1fr);
  }
  
  .partners-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .info-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .intro-box {
    flex-direction: column;
  }
  
  .intro-image {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .banner-title {
    font-size: 28px;
  }
  
  .stats-container {
    gap: 60px;
  }
  
  .gallery-grid,
  .ip-grid,
  .partners-grid,
  .info-grid {
    grid-template-columns: 1fr;
  }
  
  .section {
    padding: 0 20px;
  }

  /* 媒体中心 */
  .media-section-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
  }

  .title-left {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .title-icon-box {
    width: 24px;
    height: 24px;
    object-fit: contain;
    flex-shrink: 0;
    display: block;
    margin: 0;
    padding: 0;
  }

  .media-list {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 0;
    padding-left: 0;
  }

  .media-item {
    display: flex !important;
    align-items: center !important;
    gap: 12px !important;
    padding: 16px 0 !important;
    border-bottom: none !important;
    cursor: pointer !important;
    transition: all 0.3s ease !important;
  }

  .media-item:hover {
    background-color: #f9f9f9 !important;
    padding-left: 8px !important;
  }

  .media-item:last-child {
    border-bottom: none !important;
  }

  .media-item-bullet {
    color: #d0d0d0 !important;
    font-size: 8px !important;
    font-weight: bold !important;
    flex-shrink: 0 !important;
    width: 6px !important;
    height: 6px !important;
    border-radius: 50% !important;
    background: #d0d0d0 !important;
    line-height: 1 !important;
  }

  .media-item-title {
    flex: 1 !important;
    font-size: 14px !important;
    color: #666666 !important;
    line-height: 1.6 !important;
  }

  .media-item-date {
    font-size: 12px !important;
    color: #cccccc !important;
    white-space: nowrap !important;
    flex-shrink: 0 !important;
    margin-left: 0 !important;
  }
}


 

.dialog-content {
  color: #374151;
  font-size: 14px;
  line-height: 1.8;
}

.rules-text {
  color: #374151;
  font-size: 14px;
  line-height: 1.8;
}

.chapter-section {
  margin-bottom: 32px;
}

.chapter-section:last-child {
  margin-bottom: 0;
}

.chapter-title {
  font-size: 18px;
  font-weight: 700;
  color: #1F2937;
  margin: 0 0 20px 0;
  padding-bottom: 12px;
  border-bottom: 3px solid #3B82F6;
  display: inline-block;
}

.section-subtitle {
  font-size: 15px;
  font-weight: 600;
  color: #3B82F6;
  margin: 16px 0 12px 0;
  padding-left: 12px;
  border-left: 3px solid #3B82F6;
}

.article-item {
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
  padding: 12px;
  background: #F9FAFB;
  border-radius: 8px;
  border-left: 4px solid #3B82F6;
  transition: all 0.3s;
}

.article-item:hover {
  background: #EFF6FF;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.1);
}

.article-number {
  flex-shrink: 0;
  font-weight: 600;
  color: #3B82F6;
  min-width: 60px;
}

.article-text {
  flex: 1;
  color: #4B5563;
  line-height: 1.8;
  text-align: justify;
}
</style>
  
 
